import { render, staticRenderFns } from "./AzDispatch.vue?vue&type=template&id=34677682&"
import script from "./AzDispatch.vue?vue&type=script&lang=js&"
export * from "./AzDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports